import { render } from "./CloseCircle.vue?vue&type=template&id=76fc0e1c"
import script from "./CloseCircle.vue?vue&type=script&lang=js"
export * from "./CloseCircle.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/CloseCircle.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "76fc0e1c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('76fc0e1c', __exports__)) {
    api.reload('76fc0e1c', __exports__)
  }
  
  module.hot.accept("./CloseCircle.vue?vue&type=template&id=76fc0e1c", () => {
    api.rerender('76fc0e1c', render)
  })

}


export default __exports__